<template>
    <div class="page-head">
        <div class="btn btn-back" @click="comp.onClose()"><i class="las la-times"></i></div>
    </div>
    <div class="page-body">
        <div class="view-cont">
            <div class="view-body">
                <div>
                    <select class="select-voice" v-model="comp.selected" @change="comp.doEvaluates">
                        <template v-for="(irow, i) in comp.list" :key="i">
                            <option :value="i">{{ irow["script"] }}</option>
                        </template>
                    </select>
                    <button class="btn btn-play" @click="comp.onPlay(comp.view)">
                        <i v-if="comp.play.idx==comp.view.idx" class="las la-volume-up"></i>
                        <i v-else class="las la-play"></i>
                    </button>
                </div>

                <div class="ex-box result-box">
                    <div>
                        <div class="tit">[분석결과]</div>
                        <span class="script">
                            <span class="speech">Pronunciation : {{ (comp.view.report.phonemes_length).toFixed(2) }}</span>
                            <span class="speech">Pitch Direction : {{ (comp.view.report.pitch_direction).toFixed(2) }}</span>
                            <span class="speech">Pitch Distance : {{ (comp.view.report.pitch_distance).toFixed(2) }}</span>
                            <span class="speech">Speech Time : {{ (comp.view.report.speech_time).toFixed(2) }}s</span>
                            <span class="speech">WPM : {{ (comp.view.report.wpm).toFixed(2) }}w/m</span>
                        </span>
                    </div>

                    <div>
                        <div class="tit">[Pronunciation]</div>
                        <span><span>{{ comp.view.text }}</span></span><br>
                        <template v-for="(irow, i) in comp.view.phonemes" :key="i">
                            <span :score="irow.score" :class="{ 'hover':comp.view.hover==i }"><span :class="comp.mkClass(comp.view, i)" @mouseover="comp.onHover(i)" @mouseleave="comp.onHover(-1)" @click="comp.onSelect(i)">{{ irow.token_txt }}</span></span>
                        </template>
                    </div>
                    <!-- pronunciation analysis chart -->
                    <div class="chart" style="margin-top:10px">
                        <PronunciationChart :width="comp.pronunciation.w" :height="comp.pronunciation.h" :labels="comp.pronunciation.labels" :datalist="comp.pronunciation.datalist"></PronunciationChart>
                    </div>

                    <div class="cb">
                        <div class="tit">[Picth Direction]</div>
                    </div>
                    <!-- pitch direction analysis chart -->
                    <div class="chart" style="margin-top:10px">
                        <PitchChart :width="comp.pitch_dir.w" :height="comp.pitch_dir.h" :labels="comp.pitch_dir.labels" :datalist="comp.pitch_dir.datalist"></PitchChart>
                    </div>

                    <div class="cb">
                        <div class="tit">[Picth Distance]</div>
                    </div>
                    <!-- pitch distance analysis chart -->
                    <div class="chart" style="margin-top:10px">
                        <DistanceChart :width="comp.pitch_dis.w" :height="comp.pitch_dis.h" :labels="comp.pitch_dis.labels" :datalist="comp.pitch_dis.datalist"></DistanceChart>
                    </div>

                </div>
            </div>

            <div class="ex-pron" v-if="comp.phoneme.show">
                <div class="ex-bg" @click="comp.deSelect()"></div>
                <div class="ex-box">
                    <button class="btn-ex-close" @click="comp.deSelect()"><i class="lar la-times-circle"></i></button>
                    <table>
                        <tr>
                            <th rowspan="2">Phoneme<br>Pronunciation</th>
                            <th :colspan="comp.phoneme.list.length">{{ comp.phoneme.token }}</th>
                        </tr>
                        <tr>
                            <template v-for="(irow, i) in comp.phoneme.list" :key="i">
                                <th>{{ irow.pron }}</th>
                            </template>
                        </tr>
                        <tr>
                            <td>Min-Max Length(ms)</td>
                            <template v-for="(irow, i) in comp.phoneme.list" :key="i">
                                <td>{{ irow.min }}-{{ irow.max}}</td>
                            </template>
                        </tr>
                        <tr>
                            <td>Average Length(ms)</td>
                            <template v-for="(irow, i) in comp.phoneme.list" :key="i">
                                <td>{{ irow.avg.toFixed(1) }}</td>
                            </template>
                        </tr>
                        <tr>
                            <td>Length(ms)</td>
                            <template v-for="(irow, i) in comp.phoneme.list" :key="i">
                                <td>{{ irow.len }}</td>
                            </template>
                        </tr>
                        <tr>
                            <td>Percentage error(%)</td>
                            <template v-for="(irow, i) in comp.phoneme.list" :key="i">
                                <td>{{ irow.erate }}</td>
                            </template>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <audio id="pop-audioplayer" class="rr-voice" :src="comp.play.vpath" @ended="comp.gotEnded"></audio>

    </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import axios from "axios";

import PronunciationChart from '@/components/Charts/PronunciationChart';
import PitchChart from '@/components/Charts/PitchChart';
import DistanceChart from '@/components/Charts/DistanceChart';
import { useEvaluator } from '@/utils/prontest'

export default {
    name: "SpacView",
    components: {
        PronunciationChart,
        PitchChart,
        DistanceChart,
    },
    props:{ },
    setup() {
        // const toast  = useToast();
        const route = useRoute();
        const store = useStore()
        const ev = useEvaluator()

        const comp = reactive({
            uidx : 0,
            idx_exam : 0, part : "",
            view : { 
                idx:0, show:'N', phonemes:[], result:[], text:'', hover:-1, vpath:'', avg_score:0, avg_grade:0, avg_score_p:0, len_tot:0, words_cnt:0, best_match:0, pitch_dist : [],
                report : { phonemes_length:0, pitch_direction:0, pitch_distance:0, speech_time:0, wpm:0 }
            },
            phoneme : { idx:-1, show:false, list:[], token:"" },
            pronunciation : { w:'538', h:'150', labels:[], datalist:[[], []] },      // pronunciation
            pitch_dir : { w:'538', h:'150', labels:[], datalist:[[], []] },    // pitch direction
            pitch_dis : { w:'538', h:'150', labels:[], datalist:[[], []] },  // pitch distance
            zIndex : -9,
            audioplayer2 : null,
            play: { idx:0, vpath:"", status:0 },
            control : {
                // 분석 대상이 되는 원어민
                idxl : [],
                list : [],
                lens : [],
                pers : [],
                avgs : [],
                pitch : { dist:0, min:0, max:0 },
            },
            opts : {
                base : { 
                    best:10, good:20, average:30, fair:40, poor:'etc', 
                    pitch_weight:20, pitch_weight_dist:10, 
                    pitch_guide:{ 
                        best:30, good:50, average:70, fair:90, poor:'etc'
                    } 
                },
                usepitchdist : true
            },
            natives: [], info: {},
            selected : 0,

            doInit:(iv)=>{
                // console.log(iv)
                comp.zIndex = 999

                comp.view.idx = iv.idx

                comp.view.text = iv.script
                comp.view.result = iv.result

                let vpath = "/ai/voice?file=" + encodeURIComponent(iv.vpath)
                comp.view.vpath = vpath
                comp.view.vpath = iv.wpath

                if( comp.control.lens.length <= 0 ) {
                    console.log("ERR:: control length")
                    return
                }
                // if( !iv.avg_score ) {
                //     console.log("ERR:: avg score")
                //     return
                // }


                comp.view.phonemes = iv.phonemes
                comp.view.report = iv.report

                // comp.view.avg_score = iv.avg_score
                comp.view.avg_grade = iv.avg_grade
                comp.view.len_tot = iv.len_tot
                comp.view.words_cnt = iv.words_cnt

                comp.view.show = 'Y'

                comp.view.avg_score_p = iv.avg_score_p
                comp.view.best_match = iv.pitch_dir.best

                comp.view.pitch_dist = iv.pitch_dist

                comp.makeChartData()
            },
            makeChartData:() => {
                let slist = comp.view.result
                let clist = comp.control.list
                let data_cnt = 0
                let best_idx = (comp.control.idxl.indexOf(comp.view.best_match))


                ////////////////////////////////////////////////////////////////
                // student pronunciation length add
                comp.pronunciation.labels = []
                comp.pronunciation.datalist = [{label:'Student Pronunciation', data:[]}]

                // student pronunciation length data add
                for(let i=0; i<slist.length; i++) {
                    let irow = slist[i]
                    comp.pronunciation.labels.push(irow['pron'])
                    comp.pronunciation.datalist[data_cnt]['data'].push(irow['len'])
                }

                // native pronunciation length data add
                data_cnt++
                for(let i=0; i<clist.length; i++) {
                    let irow = clist[i]

                    for(let j=0; j<irow.length; j++){
                        let jrow = irow[j]

                        // native n pronunciation add
                        if( !comp.pronunciation.datalist[data_cnt] ) {
                            comp.pronunciation.datalist[data_cnt] = {
                                label:'Native' + data_cnt + ' Pronunciation ',
                                data : []
                            }

                            if( i==best_idx ){
                                comp.pronunciation.datalist[data_cnt].label = 'Best Match'
                                comp.pronunciation.datalist[data_cnt].isBest = true
                            }
                        }
                        comp.pronunciation.datalist[data_cnt]['data'].push(jrow['len'])
                    }

                    data_cnt++
                }



                ////////////////////////////////////////////////////////////////
                // student pitch original add
                comp.pitch_dir.labels = []
                comp.pitch_dir.datalist = [{label:'Student Direction', data:[]}]

                // student pitch original data add
                data_cnt = 0
                for(let i=0; i<slist.length; i++) {
                    let irow = slist[i]
                    comp.pitch_dir.labels.push(irow['pron'])
                    comp.pitch_dir.datalist[data_cnt]['data'].push(irow['pitch_dir'])
                }

                // native pitch original data add
                data_cnt++
                for(let i=0; i<clist.length; i++) {
                    let irow = clist[i]

                    for(let j=0; j<irow.length; j++){
                        let jrow = irow[j]

                        // native n pitch add
                        if( !comp.pitch_dir.datalist[data_cnt] ) {
                            comp.pitch_dir.datalist[data_cnt] = {
                                label:'Native' + data_cnt + ' Direction ',
                                data : []
                            }

                            if( i==best_idx ){
                                comp.pitch_dir.datalist[data_cnt].label = 'Best Match'
                                comp.pitch_dir.datalist[data_cnt].isBest = true
                            }
                        }
                        comp.pitch_dir.datalist[data_cnt]['data'].push(jrow['pitch_dir'])
                    }
                    data_cnt++
                }



                ////////////////////////////////////////////////////////////////
                // student distance add

                let labels = []
                let datas  = []

                // // student distance data add
                labels.push('Student Distance')
                let dat = [ 
                    comp.view.pitch_dist.min.toFixed(2), 
                    comp.view.pitch_dist.max.toFixed(2), 
                    comp.view.pitch_dist.val.toFixed(2) ]
                if( comp.view.pitch_dist.min == 1000 && comp.view.pitch_dist.max == 0 ){
                    dat[0] = 0
                }
                datas.push(dat)
                // console.log(datas)


                // native distance data add
                clist = comp.control.pitch.dlst
                for(let i=0; i<clist.length; i++) {
                    let irow = clist[i]

                    labels.push('Native' + (i+1) + ' Distance')
                    datas.push([ 
                    irow.min.toFixed(2), 
                    irow.max.toFixed(2), 
                    irow.dist.toFixed(2) ])

                }

                comp.pitch_dis.labels = labels
                comp.pitch_dis.datalist = [
                    {
                        label :'Pitch Distance', 
                        data : datas
                    }
                ]

            },

            onClose:() => {
                self.close()
                window.close()
            },

            onHover:(j) => {
                comp.view.hover = j
            },

            mkClass:(ir, j)=>{
                let jr = ir.phonemes[j]
                return 'phonemes-' + j + ' ' + (!jr.grade?'':jr.grade)
            },
            onPlay:(o) => {
                if( o ){
                    comp.play.idx = o.idx
                    comp.play.vpath = o.vpath
                    setTimeout(() =>{
                        comp.audioplayer2.play();
                    }, 200)
                }
            },
            gotEnded:() => {
                console.log('play done')
                comp.play.idx = 0
                comp.play.status = 0
            },
            onSelect:(j)=>{
                comp.phoneme.idx = j
                comp.phoneme.show = true
                comp.phoneme.token = comp.view.phonemes[j].token
                comp.phoneme.list = comp.view.phonemes[j].analysis
                // console.log(comp.phoneme.list)
            },
            deSelect:() => {
                comp.phoneme.idx = -1
                comp.phoneme.show = false
            },


            doEvaluates: () => {
                // console.log(comp.selected)

                ev.opts = comp.opts

                let target = comp.list[comp.selected]

                let ctrls = []
                for (let i = 0; i < comp.natives.length; i++) {
                    let irow = comp.natives[i]

                    if (irow.idx_spac_script == target.idx_spac_script) {
                        ctrls.push(irow)
                    }
                }
                comp.control = ev.getRules(ctrls)

                // console.log(comp.control)

                target = ev.run(target, comp.control)
                comp.doInit(target)
            },

            doSearch: () => {
                let params = {
                    idx_exam : comp.idx_exam,
                    part     : comp.part
                }
                axios.get("/ai/spac_info", { params:params }).then((res) => {
                    if( res.data.err == 0 ){
                        comp.list = res.data.list
                        comp.natives = res.data.natives

                        comp.selected = 0

                        comp.doEvaluates()
                    }
                })
            },
        })

        onMounted(() => {
            comp.audioplayer2 = document.getElementById("pop-audioplayer")

            comp.idx_exam = route.params.idx

            comp.part = (route.query.part?route.query.part:"")

            comp.uidx = store.state.user.idx

            comp.doSearch()
        })

        return { comp };
    }
}
</script>

<style lang="scss">
    @import "@/scss/_variables.scss";
    .page-head {
        position:fixed; top:0; left:0; width:100%; height:50px; z-index:910; background-color:#fff; border-bottom: 1px solid #ececec;
        .btn-back {
            position:fixed; top:5px; left:0; width:40px; height:40px; font-size:30px; text-align:center; line-height:40px; color:#929292; z-index:2;
        }
    }
    .page-body {
        position:fixed; top:50px; left:0; width:100%; height:calc(100% - 50px); background-color:#fff;
        .view-cont {
            max-width:800px;
            .select-voice {
                width:calc(100% - 60px); height:32px; border-radius:0; margin:10px; margin-bottom:0; padding-left:10px; border-color:#c8c8c8; color:#666; outline:none;
            }
            .btn-play {
                width:32px; height:32px; border:1px solid #c8c8c8; border-radius:none; margin-top:10px;
            }
            .view-body {
                text-align:left;
                .ex-box {
                    word-break: break-all;
                    font-size:1rem; color:#666; text-align:left; padding:10px; 
                    .tit {
                        padding:20px 0 5px; font-size:11px;
                    }
                    .btn {
                        display:inline-block; border:1px solid rgba(29, 166, 0, 1); border-radius:20px; width:16px; height:16px; font-size:13px; line-height:15px; padding:0; margin:0; text-align:center; color:#fff; background-color:rgba(29, 166, 0, 0.6); vertical-align:top; margin-top:2px; margin-left:6px;
                    }
                    .script {
                        .speech {
                            font-size:15px; margin-left:20px;
                            &:first-child {
                                margin-left:0;
                            }
                        }
                    }
                }
                .result-box {
                    .hover {
                        background-color:rgba(0,0,0,0.1)
                    }
                    .best { color:#4744f7; }
                    .good { color:#1da600; }
                    .average { color:#ffeb00; }
                    .fair { color:#fab905; }
                    .poor { color:#fc2415; }
                    span {
                        font-size:11px;
                        > span {
                            font-size:18px; cursor:pointer;
                        }
                    }
                }
                .chart {
                    position:relative; width:100%; height:150px;
                }
            }
            .ex-pron {
                position:absolute; top:0; left:0; right:0; bottom:0; margin:auto;
                text-align:center; background-color:rgba(200,200,200,0.4); vertical-align: middle;
                .ex-box {
                    position:relative; display:inline-block;
                    vertical-align: middle; margin:50px auto 0; text-align:center;
                    table {
                        border-radius:4px; background-color:#fff; box-shadow: 0px 0px 8px #999;
                        th {
                            padding:10px 0 6px;
                            border-bottom:1px solid #c8c8c8;
                        }
                        td {
                            padding:6px 10px 10px;
                        }
                    }
                    .btn-ex-close {
                        position:absolute; top:-20px; left:calc(50% - 10px); width:20px; height:20px; background-color:transparent; border:0; line-height:20px; padding:0; color:#fff; font-size:16px; text-shadow: rgb(0, 0, 0) 0 0 8px;
                    }
                }
                .ex-bg {
                    position:absolute; top:0; left:0; width:100%; height:100%;
                }
            }
        }
    }
</style>
